export const staffRemindersMockData = [
  {
    reminderId: 'REM-001',
    staffId: 'STAFF-123',
    staffName: 'Nurse Sarah Collins',
    reminderTitle: 'Team Meeting',
    reminderDetails: 'Weekly nursing staff meeting in Conference Room A',
    reminderDate: '2025-03-28T15:00:00',
    isAcknowledged: true,
    priority: 'Medium',
    category: 'Meeting',
    department: 'Nursing',
    createdBy: 'Claire Wilson',
    createdAt: '2025-03-25T09:00:00'
  },
  {
    reminderId: 'REM-002',
    staffId: 'STAFF-145',
    staffName: 'Nurse Michael Chen',
    reminderTitle: 'Medication Training',
    reminderDetails: 'Updated protocol training for new chemotherapy drugs',
    reminderDate: '2025-04-05T10:00:00',
    isAcknowledged: false,
    priority: 'High',
    category: 'Training',
    department: 'Nursing',
    createdBy: 'Dr. Mark Robinson',
    createdAt: '2025-04-01T14:30:00'
  },
  {
    reminderId: 'REM-003',
    staffId: 'STAFF-167',
    staffName: 'Nurse Amanda Rodriguez',
    reminderTitle: 'Patient Discharge',
    reminderDetails: 'Prepare discharge papers for patient Daniel Clark',
    reminderDate: '2025-03-30T14:00:00',
    isAcknowledged: true,
    priority: 'High',
    category: 'Patient Care',
    department: 'Nephrology',
    createdBy: 'Dr. Amanda Lewis',
    createdAt: '2025-03-28T16:45:00'
  },
  {
    reminderId: 'REM-004',
    staffId: 'STAFF-189',
    staffName: 'PT Daniel Morris',
    reminderTitle: 'Equipment Maintenance',
    reminderDetails: 'Schedule maintenance for physical therapy equipment in Room E-120',
    reminderDate: '2025-04-06T09:00:00',
    isAcknowledged: false,
    priority: 'Medium',
    category: 'Maintenance',
    department: 'Physical Therapy',
    createdBy: 'James Wilson',
    createdAt: '2025-04-01T11:20:00'
  },
  {
    reminderId: 'REM-005',
    staffId: 'STAFF-210',
    staffName: 'Nurse David Chen',
    reminderTitle: 'Ventilator Training',
    reminderDetails: 'Refresher training on new ventilator models',
    reminderDate: '2025-04-07T14:00:00',
    isAcknowledged: false,
    priority: 'Critical',
    category: 'Training',
    department: 'ICU',
    createdBy: 'Dr. Lisa Thompson',
    createdAt: '2025-04-01T08:15:00'
  },
  {
    reminderId: 'REM-006',
    staffId: 'STAFF-245',
    staffName: 'Nurse Jennifer Lopez',
    reminderTitle: 'Medication Inventory',
    reminderDetails: 'Complete inventory of oncology medications and supplies',
    reminderDate: '2025-03-29T11:00:00',
    isAcknowledged: true,
    priority: 'Medium',
    category: 'Administrative',
    department: 'Oncology',
    createdBy: 'Pharmacy Director',
    createdAt: '2025-03-25T15:30:00'
  },
  {
    reminderId: 'REM-007',
    staffId: 'STAFF-123',
    staffName: 'Nurse Sarah Collins',
    reminderTitle: 'Patient Follow-up',
    reminderDetails: 'Call discharged patient David Miller to check on recovery progress',
    reminderDate: '2025-04-04T13:00:00',
    isAcknowledged: false,
    priority: 'Medium',
    category: 'Patient Care',
    department: 'Cardiology',
    createdBy: 'Dr. Maria Garcia',
    createdAt: '2025-04-01T09:45:00'
  },
  {
    reminderId: 'REM-008',
    staffId: 'STAFF-145',
    staffName: 'Nurse Michael Chen',
    reminderTitle: 'Shift Change',
    reminderDetails: 'Temporary shift change next week, covering evening shift',
    reminderDate: '2025-03-31T07:00:00',
    isAcknowledged: true,
    priority: 'High',
    category: 'Schedule',
    department: 'Nursing',
    createdBy: 'Claire Wilson',
    createdAt: '2025-03-27T10:00:00'
  },
  {
    reminderId: 'REM-009',
    staffId: 'STAFF-167',
    staffName: 'Nurse Amanda Rodriguez',
    reminderTitle: 'Certification Renewal',
    reminderDetails: 'Your BLS certification expires in 30 days',
    reminderDate: '2025-05-03T00:00:00',
    isAcknowledged: false,
    priority: 'Medium',
    category: 'Certification',
    department: 'Nursing',
    createdBy: 'HR Department',
    createdAt: '2025-04-01T08:00:00'
  },
  {
    reminderId: 'REM-010',
    staffId: 'STAFF-189',
    staffName: 'PT Daniel Morris',
    reminderTitle: 'Documentation Due',
    reminderDetails: 'Complete progress notes for patient Jessica Lee',
    reminderDate: '2025-03-27T17:00:00',
    isAcknowledged: false,
    priority: 'High',
    category: 'Documentation',
    department: 'Physical Therapy',
    createdBy: 'System',
    createdAt: '2025-03-25T12:00:00'
  },
  {
    reminderId: 'REM-011',
    staffId: 'STAFF-210',
    staffName: 'Nurse David Chen',
    reminderTitle: 'Code Blue Drill',
    reminderDetails: 'Mandatory participation in emergency response drill',
    reminderDate: '2025-04-09T11:00:00',
    isAcknowledged: false,
    priority: 'Critical',
    category: 'Training',
    department: 'All',
    createdBy: 'Safety Officer',
    createdAt: '2025-04-01T14:15:00'
  },
  {
    reminderId: 'REM-012',
    staffId: 'STAFF-245',
    staffName: 'Nurse Jennifer Lopez',
    reminderTitle: 'Performance Review',
    reminderDetails: 'Annual performance review with department head',
    reminderDate: '2025-03-26T14:30:00',
    isAcknowledged: true,
    priority: 'Medium',
    category: 'Administrative',
    department: 'Oncology',
    createdBy: 'HR Department',
    createdAt: '2025-03-20T10:00:00'
  },
  {
    reminderId: 'REM-013',
    staffId: 'STAFF-123',
    staffName: 'Nurse Sarah Collins',
    reminderTitle: 'Infection Control Meeting',
    reminderDetails: 'Review updated infection control protocols with team',
    reminderDate: '2025-04-04T09:30:00',
    isAcknowledged: false,
    priority: 'High',
    category: 'Meeting',
    department: 'Nursing',
    createdBy: 'Dr. Robert Wilson',
    createdAt: '2025-04-02T08:00:00'
  },
  {
    reminderId: 'REM-014',
    staffId: 'STAFF-145',
    staffName: 'Nurse Michael Chen',
    reminderTitle: 'Patient Education Session',
    reminderDetails: 'Conduct diabetes management education for outpatient group',
    reminderDate: '2025-04-09T13:00:00',
    isAcknowledged: false,
    priority: 'Medium',
    category: 'Patient Care',
    department: 'Endocrinology',
    createdBy: 'Dr. Emily Parker',
    createdAt: '2025-04-01T16:45:00'
  },
  {
    reminderId: 'REM-015',
    staffId: 'STAFF-167',
    staffName: 'Nurse Amanda Rodriguez',
    reminderTitle: 'Medication Reconciliation',
    reminderDetails: 'Complete medication reconciliation for newly admitted patients',
    reminderDate: '2025-03-25T11:00:00',
    isAcknowledged: true,
    priority: 'Critical',
    category: 'Patient Care',
    department: 'Nephrology',
    createdBy: 'Dr. James Wilson',
    createdAt: '2025-03-22T10:15:00'
  },
  {
    reminderId: 'REM-016',
    staffId: 'STAFF-210',
    staffName: 'Nurse David Chen',
    reminderTitle: 'Equipment Training',
    reminderDetails: 'Training session for new patient monitoring systems',
    reminderDate: '2025-04-05T10:00:00',
    isAcknowledged: false,
    priority: 'High',
    category: 'Training',
    department: 'ICU',
    createdBy: 'Medical Equipment Director',
    createdAt: '2025-04-01T09:30:00'
  },
  {
    reminderId: 'REM-017',
    staffId: 'STAFF-189',
    staffName: 'PT Daniel Morris',
    reminderTitle: 'Department Budget Review',
    reminderDetails: 'Quarterly budget and resource allocation meeting',
    reminderDate: '2025-03-22T14:00:00',
    isAcknowledged: true,
    priority: 'Medium',
    category: 'Administrative',
    department: 'Physical Therapy',
    createdBy: 'Finance Department',
    createdAt: '2025-03-15T11:00:00'
  },
  {
    reminderId: 'REM-018',
    staffId: 'STAFF-245',
    staffName: 'Nurse Jennifer Lopez',
    reminderTitle: 'Patient Transfer Protocol',
    reminderDetails: 'Review updated protocols for inter-department patient transfers',
    reminderDate: '2025-04-05T15:30:00',
    isAcknowledged: false,
    priority: 'High',
    category: 'Training',
    department: 'Oncology',
    createdBy: 'Department Head',
    createdAt: '2025-04-02T13:20:00'
  },
  {
    reminderId: 'REM-019',
    staffId: 'STAFF-123',
    staffName: 'Nurse Sarah Collins',
    reminderTitle: 'Electronic Health Record Update',
    reminderDetails: 'Mandatory training on new EHR system features',
    reminderDate: '2025-04-13T09:00:00',
    isAcknowledged: false,
    priority: 'Critical',
    category: 'Training',
    department: 'All',
    createdBy: 'IT Department',
    createdAt: '2025-04-01T14:00:00'
  },
  {
    reminderId: 'REM-020',
    staffId: 'STAFF-145',
    staffName: 'Nurse Michael Chen',
    reminderTitle: 'Annual TB Test Due',
    reminderDetails: 'Schedule your annual tuberculosis screening test',
    reminderDate: '2025-04-15T00:00:00',
    isAcknowledged: false,
    priority: 'Medium',
    category: 'Compliance',
    department: 'Nursing',
    createdBy: 'Occupational Health',
    createdAt: '2025-04-01T08:30:00'
  },
  {
    reminderId: 'REM-021',
    staffId: 'STAFF-123',
    staffName: 'Nurse Sarah Collins',
    reminderTitle: 'Weekly Status Report',
    reminderDetails: 'Submit weekly patient status reports for Ward A',
    reminderDate: '2025-03-28T16:00:00',
    isAcknowledged: true,
    priority: 'Medium',
    category: 'Administrative',
    department: 'Nursing',
    createdBy: 'Department Head',
    createdAt: '2025-03-25T09:00:00'
  },
  {
    reminderId: 'REM-022',
    staffId: 'STAFF-210',
    staffName: 'Nurse David Chen',
    reminderTitle: 'Infection Control Training',
    reminderDetails: 'Complete mandatory infection control refresher course',
    reminderDate: '2025-03-24T10:00:00',
    isAcknowledged: true,
    priority: 'High',
    category: 'Training',
    department: 'ICU',
    createdBy: 'Infection Control Officer',
    createdAt: '2025-03-17T14:30:00'
  },
  {
    reminderId: 'REM-023',
    staffId: 'STAFF-167',
    staffName: 'Nurse Amanda Rodriguez',
    reminderTitle: 'Inventory Check',
    reminderDetails: 'Conduct monthly supply inventory for Nephrology department',
    reminderDate: '2025-03-31T11:30:00',
    isAcknowledged: true,
    priority: 'Medium',
    category: 'Administrative',
    department: 'Nephrology',
    createdBy: 'Supply Manager',
    createdAt: '2025-03-28T09:15:00'
  }
]
